import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from "@core/scripts/helper/jsh-module";
import WishlistHeart from '@shopping-funnel/scripts/components/wishlist/WishlistHeart.jsx';

// Find all elements with the jsh-module attribute
const elements = document.querySelectorAll('[jsh-module="teaser/add-to-wishlist"]');

elements.forEach((el) => {
    const {moduleScope, config} = JshModule('teaser/add-to-wishlist', el);
    // Ensure moduleScope is a valid DOM element
    if (!moduleScope || !(moduleScope instanceof Element)) return;

    const {articleNumber, promotion, shopId, digistyleId, itemId, formattedPrice, itemOptionName} = config;
    const productCardItem = {
        digistyleId: digistyleId,
        articleNumber: articleNumber,
        itemId: itemId,
        sizeText: itemOptionName,
        wishlistLandmarkData: {
            promotion: promotion,
            decimalPrice: formattedPrice,
            shopId: shopId,
            origin: "Contentful Product Slider hbs version",
        }
    }

    createRoot(moduleScope).render(
        <div
            className={"content-platform__add-to-wishlist-heart content-platform__add-to-wishlist-heart__product-slider"}>
            <WishlistHeart
                key={itemId}
                iconButtonVariant={'tertiary'}
                productCardItem={productCardItem}
                usedInRecommendation={true}
            />
        </div>
    );
});
